import React from "react";

const CrossIcon = (props: any) => {
  return (
    <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#FFF0EF" />
      <path d="M21 11L11 21M11 11L21 21" stroke="#FF6961" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default CrossIcon;
